import SiteQuery from "../../domain/core/site/SiteQuery";
import { SiteModel } from "../../domain/models/Site";
import { IQuerySiteRepository } from "../../domain/ports/sites/IQuerySiteRepository";
import QueryService from "../QueryService";

export class SiteQueryService
  extends QueryService<SiteModel>
  implements IQuerySiteRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const siteQueryService = new SiteQuery(new SiteQueryService(BASE_URL, "sites"));

export { siteQueryService };
